import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { get } from 'lodash';

// local dependencies
import { getVisibleItems } from 'resolvers/getVisibleEntities';

/*************************************************************/

/**
 * @type {class}
 * @desc MemberHealthInfo defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberHealthInfoService } from 'services/memberHealthInfo';
 *
 * // create service instance and send/cancel request
 * const memberHealthInfoService = new MemberHealthInfoService();
 * const result = await memberHealthInfoService.fetchData( '<user-id>' ); // fetch data
 * memberHealthInfoService.cancel(); // cancel an active request
 */
export class MemberHealthInfoService extends HttpService {

    // make request and fetch data
    async fetchData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            // extract component data
            const visibility = get( response, 'body.component.visibility', {} );
            const tabs = get( response, 'body.component.structure.tabs', [] );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ),
                data: {
                    tabs: getVisibleItems( tabs, visibility ),
                },
            };
        } catch( errResponse ) {
            return this._errorFormatter( errResponse );
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
